export const ACTION_TYPES = {
  REQUEST_REGISTER: 'REQUEST_REGISTER',
  RECEIVE_REGISTER: 'RECEIVE_REGISTER',
  RECEIVE_CHECKREGISTER: 'RECEIVE_CHECKREGISTER'
};

const initialState = { entity: null, isLoading: false, status: null };

export const registerActions = {
  createCustomer: (data, onProgress) => async (dispatch) => {

    dispatch({ type: ACTION_TYPES.REQUEST_REGISTER });
    const token = localStorage.getItem('verificationToken');

    const url = `api/register`;

    let formData = new FormData();

    const flattened = flattenObject(data);

    for (let key in flattened) {
        formData.append(key, flattened[key]);
    }

    // Use XMLHttpRequest for upload progress tracking
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      // Track upload progress
      xhr.upload.addEventListener('progress', (e) => {
        if (e.lengthComputable) {
          const percentComplete = (e.loaded / e.total) * 100;
          if (onProgress) {
            onProgress(percentComplete);
          }
        }
      });

      // Handle completion
      xhr.addEventListener('load', () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const entity = JSON.parse(xhr.responseText);
            dispatch({ type: ACTION_TYPES.RECEIVE_REGISTER, entity });
            resolve(entity);
          } catch (error) {
            reject(error);
          }
        } else {
          // Handle error responses (400, 500, etc.)
          try {
            const errorData = JSON.parse(xhr.responseText);
            const errorWithStatus = new Error(`HTTP Error: ${xhr.status}`);
            errorWithStatus.status = xhr.status;
            errorWithStatus.data = errorData;
            dispatch({ type: ACTION_TYPES.RECEIVE_REGISTER, entity: errorData });
            reject(errorWithStatus);
          } catch (parseError) {
            const error = new Error(`HTTP Error: ${xhr.status}`);
            error.status = xhr.status;
            error.data = { message: xhr.responseText || 'Unknown error occurred' };
            reject(error);
          }
        }
      });

      // Handle errors
      xhr.addEventListener('error', () => {
        reject(new Error('Network error occurred'));
      });

      xhr.addEventListener('abort', () => {
        reject(new Error('Upload aborted'));
      });

      // Open and send request
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      xhr.setRequestHeader('Access-Control-Origin', '*');

      xhr.send(formData);
    });

  },
  
  customerActivation: (reff) => async (dispatch) => {
    
    const url = `api/register/activation?ref=${reff}`;
    const response = await fetch(url, {
      method: "GET",
      contentType: false,
      processData: false
    });

    return dispatch(response);

  },

  checkRegisterStatus: (data) => async (dispatch) => {
    const url = `api/register/status/` + data;

    const response = await fetch(url, {
      method: "GET"
    });

    const statusRegister = await response.text();

    dispatch({ type: ACTION_TYPES.RECEIVE_CHECKREGISTER, statusRegister });

  }
};

const flattenObject = (obj, parentKey = '', result = {}) => {
    for (let key in obj) {
        if (!obj.hasOwnProperty(key)) continue;

        const propName = parentKey ? `${parentKey}.${key}` : key;

        if (
            typeof obj[key] === 'object' &&
            obj[key] !== null &&
            !(obj[key] instanceof File)
        ) {
            flattenObject(obj[key], propName, result);
        } else {
            result[propName] = obj[key];
        }
    }
    return result;
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case (ACTION_TYPES.REQUEST_REGISTER):
      return {
        ...state,
        isLoading: true
      };
    case (ACTION_TYPES.RECEIVE_REGISTER):
      return {
        ...state,
        isLoading: false,
        entity: action.entity
      }
    case (ACTION_TYPES.RECEIVE_CHECKREGISTER):
      return {
        ...state,
        isLoading: false,
        status: action.statusRegister
      }
    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/store/Register.Reducer.js